export default __webpack_public_path__ + "static/media/ic_cog.368b0bae.svg";